import { render, staticRenderFns } from "./FaPage.vue?vue&type=template&id=4ad5d845&scoped=true&"
import script from "./FaPage.vue?vue&type=script&lang=js&"
export * from "./FaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad5d845",
  null
  
)

export default component.exports